module.exports = __webpack_public_path__ + "img/stop-circle.7290c06a.svg";